module.exports = __webpack_public_path__ + "static/media/sendMessageIcon.7e985a28.svg";